import axios from 'axios';

export default async function addUserAccessibleCompanyGroups({
  accessToken,
  userId,
  companyGroupId,
  setTokenLikeExpired,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_AUTH_API_URL}/add-user-accessible-company-groups/${userId}`,
      {
        companyGroupId,
      },
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) return setTokenLikeExpired();

    return null;
  }
}
